import script from "./VolunteerServeInvitation.vue?vue&type=script&setup=true&lang=js"
export * from "./VolunteerServeInvitation.vue?vue&type=script&setup=true&lang=js"

import "./VolunteerServeInvitation.vue?vue&type=style&index=0&id=a70f5d5e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a70f5d5e"]])

export default __exports__